'use client';

import { ReactNode } from 'react';

import { Tile } from '.';
import { Loader } from '../Loader';

interface TileLoaderProps {
  footerComponent?: ReactNode;
  className?: string;
}

export const TileLoader: React.FC<TileLoaderProps> = ({
  footerComponent,
  className,
}: TileLoaderProps) => {
  return (
    <Tile
      className={className}
      overlay={
        <Loader
          theme='secondary'
          size='xlarge'
        />
      }
      footerComponent={footerComponent}
    />
  );
};
